import React from 'react';
import PropTypes from 'prop-types';

import IconSearch from '@spothero/icons/search';
import IconSlider from '@spothero/icons/slider';
import IconTimesCircle from '@spothero/icons/times-circle';

import {
    Box,
    InputLeftElement,
    Icon,
    InputGroup,
    Button,
    InputRightElement,
} from '@spothero/ui';

import Badge from 'common/badge/Badge';
import Input from 'common/input/Input';
import {useSearchField} from 'react-aria';
import {useSearchFieldState} from 'react-stately';

const inputStyleProps = {
    backgroundColor: 'gray.light',
    paddingLeft: 10,
    paddingRight: 10,
    minWidth: '100%',
    width: '100%',
};

const badgeStyleProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: -1.5,
    right: -2,
    width: 5,
    height: 5,
    fontSize: 'xs',
    fontWeight: 'normal',
};

const buttonStyleProps = {
    position: 'relative',
    width: 20,
    paddingX: 3.5,
    paddingY: 3,
    borderRadius: 'lg',
    color: 'black',
    fontWeight: 'normal',
};

const FacilitySearch = ({numFiltersApplied, onFiltersToggle, ...props}) => {
    const state = useSearchFieldState(props);
    const ref = React.useRef(null);
    const {inputProps} = useSearchField(props, state, ref);
    const noFiltersApplied = numFiltersApplied === 0;
    const handleClearSearchField = () => {
        state.setValue('');

        if (props.onClear) {
            props.onClear();
        }
    };

    return (
        <Box marginX={4}>
            <Box
                marginTop={2}
                marginBottom={4}
                display="flex"
                justifyContent="space-between"
                gap={4}
            >
                <InputGroup width="100%" display="block">
                    <InputLeftElement pointerEvents="none">
                        <Icon as={IconSearch} color="gray.dark" fontSize="sm" />
                    </InputLeftElement>
                    <Input
                        ref={ref}
                        {...inputProps}
                        placeholder="Search Facilities"
                        includeFormControl={false}
                        {...inputStyleProps}
                        data-testid="FacilitySidebarSearchInput"
                    />
                    {state.value && (
                        <InputRightElement>
                            <Button
                                aria-label="clear search"
                                variant="tertiary"
                                onClick={handleClearSearchField}
                            >
                                <Icon as={IconTimesCircle} boxSize={3} />
                            </Button>
                        </InputRightElement>
                    )}
                </InputGroup>
                <Button
                    variant="secondary"
                    onClick={onFiltersToggle}
                    {...buttonStyleProps}
                    data-testid="FacilitySidebarFiltersButton"
                >
                    <Icon as={IconSlider} boxSize={3.5} marginRight={2} />
                    Filters
                    {!noFiltersApplied ? (
                        <Badge {...badgeStyleProps}>{numFiltersApplied}</Badge>
                    ) : null}
                </Button>
            </Box>
        </Box>
    );
};

FacilitySearch.propTypes = {
    numFiltersApplied: PropTypes.number,
    onFiltersToggle: PropTypes.func,
    onClear: PropTypes.func,
};

export default FacilitySearch;
